






























export default {
  name: "UARemoveAccess",
  props: {
    width: {
      type: String,
      required: false,
      default: undefined,
    },
  },
};
